export default "__VITE_ASSET__dNCLdeMK__"